import request from './api'

export async function getCompanyInfo() {
    try {
        const res = await request('/api/resource/company-info','POST',null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getResource(func) {
    try {
        const res = await request('/api/resource/resource','POST',{func: func})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getPduAgreement() {
    try {
        const result = await request('/api/account/get-pdu-agreement', 'GET', null)
        if (result)
            return {
                isOk: true,
                result: result.result
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function getPolicyUrl() {
    try {
        const result = await request('/api/account/get-policy-url', 'GET', null)
        if (result)
            return {
                isOk: true,
                result: result.data
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function getPolicyCookies() {
    try {
        const result = await request('/api/account/get-policy-cookies', 'GET', null)
        if (result)
            return {
                isOk: true,
                result: result.data ?? null
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}
